import classNames from "classnames";
import { numberWithSpaces } from "../../utils/numberWithSpaces";

import styles from "./numberInput.module.css"
import { Text } from "../text/text";

export const NumberInput = ({ min = 0, max = 999999999, val, setVal, error, type = "int", label, withoutTransform = false, ...params }) => {
    const onChangeHandler = (e) => {
        let cur = e.target.value;
        cur = cur.replaceAll(" ", "");
        cur = cur.replaceAll(",", ".");
        if (cur === "" || cur === ".") {
            setVal("0");
            return;
        }

        cur = cur.replace(/^0+(?!\.|$)/, '');

        if (type === "int") {
            if (cur.match(/[0-9]+/) && +cur >= min && +cur <= max) {
                setVal(cur);
            } else if (+cur > max) {
                setVal(String(max));
            }
        } else {
            if (cur.match(/^\d*.?\d*$/) && +cur >= min && +cur <= max) {
                setVal(cur);
            } else if (+cur > max) {
                setVal(String(max));
            }
        }
    }

    return (
        <div className={classNames(styles.input_container, { [styles.error]: error })}>
            {label && <Text as="label" variant="caption" className={styles.label}>{label}</Text>}
            <input
                type="text"
                inputMode="decimal"
                className={styles.custom_number_input}
                value={type === "int" && !withoutTransform ? numberWithSpaces(val) : val}
                onChange={onChangeHandler}
                {...params}
            />
        </div>
    )
}